<template>
	<div class="grid">
	<div class="col-6">
		<div class="flow_wrap raised_item animate_class px-4 py-3 mb-4 flow_wrap_active"  style="min-height: 3000px;">
			<h3 class="text-primary"><b>{{folders.length}}</b></h3>
			<ul class="userlist">
				<li v-for="item in folders">
					<template v-if="item.status">
						<p class="text-green-500">{{item.id}}</p>
					</template>
					<template v-else>
						<template v-if="item.selected">
							<p class="text-prirmary" >{{item.id}}</p>
						</template>
						<template v-else>
							<p class="text-red-500" @click="selectFolder(item)">{{item.id}}</p>
						</template>
						
					</template>
					
				</li>

			</ul>

		</div>
	</div>

	<div class="col-6  ">
		<div class="flow_wrap raised_item animate_class px-4 py-3 mb-4 flow_wrap_active sticky" style="top:50px">
		<h3 v-if="selected_folder">{{selected_folder.id}}</h3>
		<template v-if="getting_files">
		<FrameOverlay></FrameOverlay>
		</template>

		<template v-else>



 		<ProgressBar :value="progress"></ProgressBar>
 		<ScrollPanel style="width: 100%; height: 200px">
			<ul class="userlist">
				<li v-for="item in folderfiles">
					<template v-if="item.status">
						<p class="text-green-500">{{item.name}}</p>
					</template>
					<template v-else>
						<p class="text-red-500">{{item.name}}</p>
					</template>
				</li>
			</ul>
		</ScrollPanel>
		</template>
		</div>

	</div>


	</div>
</template>

<script>
export default {

  name: 'FileMigrator',

  data () {
    return {
    	folders:[],
    	selected_folder:null,
    	folderfiles:[],
    	getting_files:false,
    	foldersindex:0,
    	progress:0,
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		let data = await this.generalApiGet("read_uploads_dir")
  		for(let item of data)
  		{
  			this.folders.push({id:item,status:0,selected:0})
  		}
  	},
  	calculateProgress()
  	{
  		this.progress = Math.round(((this.foldersindex+1)/this.folders.length)*100)
  	},
  	async selectFolder(folder)
  	{
  		console.log(folder)
  		 
  		//this.folderfiles = []
  		this.folders.forEach((item)=>{item.selected = 0})
  		this.foldersindex = this.folders.findIndex((item)=>{return item.id == folder.id})
  		this.folders[this.foldersindex].selected = 1
  		//this.selected_folder = folder
  		//this.getting_files = true
  		let data = await this.generalApiGet("read_evidence_dir/"+folder.id)
  		console.log(data)
  		//await this.moveFolder(folder.id)
  		/*for(let item of data)
  		{
  			item.status = 0
  			this.folderfiles.push(item)
  		}*/
  		this.folders[this.foldersindex].status = 1
  		this.showMessage("success","",data+" öğe kaydedildi")
  		this.calculateProgress()
  		//this.getting_files = false

  		this.selectNextFolder()

  	},
  	async selectNextFolder()
  	{  		
  		this.foldersindex++
  		if(this.foldersindex==this.folders.length)
  		{
  			return
  		}
  		this.folders.forEach((item)=>{item.selected = 0})
  		this.folders[this.foldersindex].selected = 1
  		let data = await this.generalApiGet("read_evidence_dir/"+this.folders[this.foldersindex].id)
  		console.log(data)
  		this.folders[this.foldersindex].status = 1
  		this.showMessage("success","",data+" öğe kaydedildi")
  		this.calculateProgress()
  		this.selectNextFolder()


  	},


  	async migrate()
  	{

  		this.moveFolder(this.selected_folder.id) 
  		let ind = this.folders.findIndex((item)=>{return item.id == this.selected_folder.id})
  		this.folders[ind].status = 1 		
  		return false
  		console.log("migrate")
  		for(let file of this.folderfiles)
  		{
  			let result = await this.moveFile(file)
  			if(result)
  			{  				
  			 file.status = await 1
  			}
  		}
  		
  	},
  	async moveFile(file)
  	{
  		console.log(file)
  		let uri = await this.generalApiGet("move_evidence_file/"+this.selected_folder.id+"?file="+file.name)
  		let api_hook = "https://api.verifyhub.io"
  		console.log(api_hook+uri)
		//this.downloadAsDataURL(api_hook+uri)
		this.downloadImage (api_hook+uri,file.name)
		  .then((res) => { 
		    console.log(res) 
		  })
		  .catch((err) => {
		    console.error(err) 
		  })
  		return true
  	},

  	async moveFolder(folder)
  	{
  		
  		let api_hook = "https://api.verifyhub.io/uploads/"+folder+".zip"
  		console.log(api_hook+"/uploads/"+folder)
		//this.downloadAsDataURL(api_hook+uri)
		setTimeout(()=>{
			this.downloadImage (api_hook,folder+".zip")
		  .then((res) => { 
		    console.log(res) 
		  })
		  .catch((err) => {
		    console.error(err) 
		  })
		},1000)
			
  		return true
  	},
  	async downloadImage(imageSrc,nameOfDownload = 'my-image.png') {
	  const response = await fetch(imageSrc);

	  const blobImage = await response.blob();

	  const href = URL.createObjectURL(blobImage);

	  const anchorElement = document.createElement('a');
	  anchorElement.href = href;
	  anchorElement.download = nameOfDownload;

	  document.body.appendChild(anchorElement);
	  anchorElement.click();

	  document.body.removeChild(anchorElement);
	  window.URL.revokeObjectURL(href);
	},
  }
}
</script>

<style lang="css" scoped>
	.userlist{
		list-style: none;
		margin: 0;
		padding: 0;
	}
</style>